/**
 * Live Topics categories (Spanish) and their assigned pill/dialog colors.
 * Colors are chosen for distinction and readability; Seguridad & Justicia uses red tones.
 */
export const LIVE_TOPICS_CATEGORIES = [
  'Actualidad',
  'Política',
  'Economía',
  'Internacional',
  'Sociedad',
  'Seguridad & Justicia',
  'Salud',
  'Educación',
  'Ciencia & Tecnología',
  'Deportes',
  'Cultura & Espectáculos',
  'Medio Ambiente',
  'Opinión',
  'Locales',
  'Other',
] as const;

/** Light-mode category colors (darker tones, readable on white/light backgrounds). */
const CATEGORY_COLOR_MAP_LIGHT: Record<string, string> = {
  Actualidad: '#4A90D9',
  Política: '#1565C0',
  Economía: '#607D8B',
  Internacional: '#2C3E50',
  Sociedad: '#00838F',
  'Seguridad & Justicia': '#C62828',
  Salud: '#00695C',
  Educación: '#FFB300',
  'Ciencia & Tecnología': '#4527A0',
  Deportes: '#EF6C00',
  'Cultura & Espectáculos': '#AD1457',
  'Medio Ambiente': '#558B2F',
  Opinión: '#5D4037',
  Locales: '#795548',
  Other: '#757575',
};

/** Dark-mode category colors (lighter/brighter tones, readable on dark backgrounds). */
const CATEGORY_COLOR_MAP_DARK: Record<string, string> = {
  Actualidad: '#64B5F6',
  Política: '#90CAF9',
  Economía: '#90A4AE',
  Internacional: '#78909C',
  Sociedad: '#4DD0E1',
  'Seguridad & Justicia': '#EF9A9A',
  Salud: '#4DB6AC',
  Educación: '#FFD54F',
  'Ciencia & Tecnología': '#CE93D8',
  Deportes: '#FFCC80',
  'Cultura & Espectáculos': '#F48FB1',
  'Medio Ambiente': '#AED581',
  Opinión: '#BCAAA4',
  Locales: '#D7CCC8',
  Other: '#B0BEC5',
};

/**
 * Returns the hex color for a topic category.
 * Unknown categories default to Other (gray).
 */
export function getCategoryColor(
  category: string | null | undefined,
  mode: 'light' | 'dark' = 'light',
): string {
  const map = mode === 'dark' ? CATEGORY_COLOR_MAP_DARK : CATEGORY_COLOR_MAP_LIGHT;
  const fallback = map.Other ?? (mode === 'dark' ? '#B0BEC5' : '#757575');
  if (!category) return fallback;
  return map[category] ?? fallback;
}
